export const clientconfig = {
  clientType: 1
}

export default clientconfig
